<template>
    <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Objeto Ação:"
    id="selectObjetoAcao"
    placeholder="Selecione o(s) Objeto(s)"
    :multiple="true"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import ObjetoAcaoRepository from '@/shared/http/repositories/configurations/objetoacao.js'

export default {
  name: 'NxSelectAjuizamentoObjetoAcao',
  mixins: [ useReactiveModelMixin('value') ],
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onLoadObjetos()
  },
  methods: {
    onLoadObjetos () {
      ObjetoAcaoRepository.GetAll()
        .then((response) => {
          let result = response.data.content
            .map((x) => ({'value': x.id, 'text': x.nome}))
          this.listOptions = result
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de Objetos de Ação', 'Erro')
          console.error(err)
        })
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectAjuizamentoObjetoAcao.vue